// extracted by mini-css-extract-plugin
export default {"products":"AddCards_products__mBr34","card_image":"AddCards_card_image__e-Ap3","read_more_button":"AddCards_read_more_button__-Kx1W"};